function truncateDecimals(num: string, decimals = 2): string {
  const decimalNumber = 10 ** decimals;
  const tenNumber = Number(num) / 1e18;
  return `${Math.floor(tenNumber * decimalNumber) / decimalNumber}`;
}

export default {
  truncateDecimals,
};
